import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-37b346f6")




export default _defineComponent({
  props: {
  title: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "app-toolbar" }, {
    default: _withId(() => [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createVNode(_component_q_toolbar_title, { class: "q-ml-md" }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(__props.title), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  }))
}
}

})